export const minReportDate = new Date('2019-11-01')



// WEBPACK FOOTER //
// ./src/config.js